angular.module('impactx.catalog').controller('CatalogRuleCheckCheckedOutItemListCtrl',
    CatalogRuleCheckCheckedOutItemListCtrl);

CatalogRuleCheckCheckedOutItemListCtrl.$inject = ['$scope', '$routeParams', '$route', 'dataGen', 'selectedListItems', 'ToastService', 'CatalogRuleService', '$mdDialog', 'OneTimeDataTransporter'];

function CatalogRuleCheckCheckedOutItemListCtrl($scope, $routeParams, $route, dataGen, selectedListItems, ToastService, CatalogRuleService, $mdDialog, OneTimeDataTransporter)
{
    var self = this;
    var resultLink = null;
    var idOfResultLink = 0;
    this.runRuleCheck = function(event, trns)
    {
        CatalogRuleService.runRuleCheck($routeParams.catId, trns.ruleCheckStarted);
        $scope.$$childHead.data.actions.runRuleCheck.allowed = false;
    };
    this.getCatalogrulecheckitemdetailLink = function () {
        return "catalogrulecheckitemdetail/" + selectedListItems.getFirstSelectedId();
    };

    this.getSpecialListLink = function () {
        if (selectedListItems.getFirstSelectedItem())
        {
            return selectedListItems.getFirstSelectedItem().poTable + "/" + selectedListItems.getFirstSelectedId();
        }
        return "";
    };

    this.hasSpecialListLink = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().numberOfErrorRules > 0 && selectedListItems.getFirstSelectedItem().hasSpecialList.value;
    };

    this.canViewCatalogrulecheckitemdetail = function() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().numberOfErrorRules > 0 && selectedListItems.getFirstSelectedItem().isStatisticRule.value &&
            selectedListItems.getFirstSelectedItem().poTable !== "catrule_product_label_statistic";
    };

    this.redirectToCheckedOutCatalogList = function () {
        if (selectedListItems.getFirstSelectedItem()) {
            if (selectedListItems.getFirstSelectedId() !== idOfResultLink) {
                resultLink = "checkedoutcataloglist/" + $routeParams.catId + "/cmrlId/" + selectedListItems.getFirstSelectedId() + "/cmrlName/" + selectedListItems.getFirstSelectedItem().numberOfErrorRules;
                idOfResultLink = selectedListItems.getFirstSelectedId();
            }
            OneTimeDataTransporter.setAndRedirect({cmrlName: selectedListItems.getFirstSelectedItem().description}, null, resultLink);
            return resultLink;
        }
    };

    this.canViewCheckedoutcataloglist = function() {
        var selectedItem = selectedListItems.getFirstSelectedItem();
        return selectedListItems.isSingleSelection() && selectedItem.numberOfErrorRules > 0 &&
            !selectedItem.isStatisticRule.value && !selectedItem.hideSearchCheckedIn.value && !selectedItem.isImportRule.value &&
            !selectedItem.isCustomCheckScope.value;
    };

    this.canViewCatalogRuleError = function () {
        var selectedItem = selectedListItems.getFirstSelectedItem();
        return selectedListItems.isSingleSelection() && selectedItem.numberOfErrorRules > 0 && !selectedItem.isStatisticRule.value && !selectedItem.isImportRule.value && selectedItem.isCustomCheckScope.value;
    };

    this.getPrintToken = function() {
        return impactX.isDefined(self, 'meta.additionalFields.printTokens.protocol');
    };

    this.ignoreRules = function () {
        CatalogRuleService.ignoreRules($routeParams.catId, selectedListItems.getSelectedIds(), true);
    };

    this.unIgnoreRules = function(){
        CatalogRuleService.unIgnoreRules($routeParams.catId, selectedListItems.getSelectedIds(), true);
    };

    this.canIgnoreRules = function (additionalFields) {
        if (additionalFields && additionalFields.canIgnoreRules && selectedListItems.isMultiSelection())
        {
            var selectedItems = selectedListItems.getSelectedItems();
            for (var i = 0; i < selectedItems.length; i++) {
                if (selectedItems[i].ignoreFilter.value || selectedItems[i].cmriStatus != 1) {
                    return false;
                }
            }
            return true;
        }
        else
        {
            return false;
        }
    };

    this.canUnIgnoreRules = function(additionalFields){
        if (additionalFields && additionalFields.canIgnoreRules && selectedListItems.isMultiSelection())
        {
            var selectedItems = selectedListItems.getSelectedItems();
            for (var i = 0; i < selectedItems.length; i++) {
               if (!selectedItems[i].ignoreFilter.value || selectedItems[i].cmriStatus != 1) {
                   return false;
               }
            }
            return true;
        }
        else
        {
            return false;
        }
    };

    this.openCatalogRuleErrorDialog = function (event) {
        if (selectedListItems.getFirstSelectedItem().isCustomCheckScope.value) {
            $mdDialog.show({
                controller: "CatalogRuleCheckErrorCtrl",
                controllerAs: 'catalogRuleCheckErrorCtrl',
                templateUrl: 'modules/catalog/templates/catalog-rule-check-error.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                targetEvent: event,
                locals: {
                    cmrliId: selectedListItems.getFirstSelectedId(),
                    catId: $routeParams.catId
                },
                bindToController: true
            })

        }
    };

    this.canRunRuleCheck = function()
    {
        return selectedListItems.isNoSelection() && impactX.isDefined($scope, '$$childHead.data.actions.runRuleCheck.allowed'); // not the best but it works here
    };

    var buttonDefinition = [
        {label: "printProtocol",
            type:'print',
            condition: selectedListItems.isNoSelection,
            process: 'CatalogRule',
            params: {
                printTokenFunction: self.getPrintToken
            }
        },
        {label: "details", action: self.redirectToCheckedOutCatalogList, condition: self.canViewCheckedoutcataloglist, process: 'CatalogRule'},
        {label: "details", linkFunction: self.getCatalogrulecheckitemdetailLink, type:'link', condition: self.canViewCatalogrulecheckitemdetail, process: 'CatalogRule'},
        {label: "details", action: self.openCatalogRuleErrorDialog, condition: self.canViewCatalogRuleError, process: 'CatalogRule'},
        {label: "catruleresultlist", linkFunction: self.getSpecialListLink, type:'link', condition: self.hasSpecialListLink, process: 'CatalogRule'},
        {label: "ignore", action: self.ignoreRules, condition: self.canIgnoreRules, process: 'CatalogRuleIgnore'},
        {label: "unignore", action: self.unIgnoreRules, condition: self.canUnIgnoreRules, process: 'CatalogRuleIgnore'},
        {label: "runRuleCheck", action: self.runRuleCheck, condition: self.canRunRuleCheck, process: 'CatalogRule'}
    ];

    this.meta = {
        rowTemplate: 'modules/catalog/templates/catalogrulecheckitemslist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/catalog/rulecheckcheckedoutitemlist',
        id: "catalogrulecheckcheckedoutitemlist",
        params: {'catId': $routeParams.catId, 'cmrlId': $routeParams.cmrlId},
        catId: $routeParams.catId,
        buttonDefinition: buttonDefinition,
        valuesInteger: [{name: 'CatId', value: $routeParams.catId}],
        hidePrint: true
    };
    this.getMeta = function () {
        return this.meta;
    };
}